module.exports = {
    id: 51,
    name: "联通年年焕新换机完成照",
    type: "changeComplete",
    form: [
        {
            label: "申请信息",
        },
        {
            label: "名称",
            type: "claims_imgs_name"
        },
        {
            label: "手机号",
            type: "claims_imgs_phone"
        },
        {
            label: "身份证号",
            type: "claims_imgs_id_card"
        },
        {
            label: "IMEI",
            type: "claims_imgs_imei"
        },
        {
            label: "手机品牌",
            type: "claims_imgs_brand"
        },
        {
            label: "手机型号",
            type: "claims_imgs_model_name"
        },
        {
            label: "手机规格",
            type: "claims_imgs_ram_size"
        },
        {
            label: "产品名称",
            type: "claims_imgs_insure_san"
        },
        {
            label: "购买子险种营业厅",
            type: "claims_imgs_name_shop_name"
        },
        {
            label: "保值金额",
            type: "claims_imgs_name_claims_money"
        },
        // {
        //     label: "手机故障项",
        //     type: "claims_imgs_name_damage_title"
        // },
        {
            label: "申请照片",
            prop: "claims_imgs",
            type: "claims_imgs"
        },
        {
            label: "换机信息",
        },
        {
            label: "新机品牌",
            prop: "brand_id",
            obj: "order",
            type: "select",
            optListName: "brandList",
            optLabel: "brand",
            optValue: "brand_id",
            relate: "model"
        },
        {
            label: "新机型号",
            prop: "model_id",
            obj: "order",
            type: "select",
            optListName: "modelList",
            optLabel: "model_name",
            optValue: "model_id"
        },
        {
            label: "新机规格",
            prop: "ram_size",
            obj: "order",
            type: "select",
            optListName: "RAMList"
        },
        {
            label: "新机IMEI",
            prop: "imei",
            obj: "order",
            type: "input"
        },
        {
            label: "旧机IMEI",
            prop: "old_imei",
            obj: "order",
            type: "input"
        },
        {
            label: "新机裸机价",
            prop: "new_price",
            obj: "order",
            type: "new_price"
        },
        {
            label: "补交金额",
            prop: "money",
            obj: "order",
            type: "span"
        },
        {
            label: "理赔金额",
            prop: "claims_money",
            obj: "order",
            type: "span"
        },

        {
            label: "收款名称",
            prop: "payment_name",
            obj: "order",
            type: "payment_name"
        },
        {
            label: "收款账号",
            prop: "payment_acc",
            obj: "order",
            type: "payment_acc"
        },
        {
            label: "收款类型",
            prop: "payType",
            obj: "order",
            type: "payType"
        },
        {
            label: "取件名称",
            prop: "send_name",
            obj: "order",
            type: "send_name"
        },
        {
            label: "取件电话",
            prop: "send_phone",
            obj: "order",
            type: "send_phone"
        },
        {
            label: "收件地址",
            prop: "send_gps",
            obj: "order",
            type: "send_gps"
        },
        {
            label: "详细地址",
            prop: "send_address",
            obj: "order",
            type: "send_address"
        },

        {
            label: "审核结果",
            prop: "exa_status",
            obj: "order",
            type: "radio",
            optListName: "statusList",
            optLabel: "name",
            optValue: "status"
        },
        {
            label: "回复内容",
            prop: "fail_exp",
            obj: "order",
            type: "fail_exp"
        },
        {
            label: "核保照片",
            prop: "tem_img",
            obj: "order",
            type: "img",
            watermark: true
        },
    ],
    tableColumns: [
        {
            slotName: "headimg"
        },
        {
            label: "注册者昵称",
            prop: "nickname"
        },
        {
            slotName: "operation"
        }
    ],
    piccCallbackType: 2
}

